// routes/generator.tsx
import type { ClientLoaderFunctionArgs } from 'react-router'
import { createRedirect } from 'src/utils/router/route'

export const handle = { name: 'generator' }

export function loader() {
  return null
}

export function clientLoader({ request }: ClientLoaderFunctionArgs) {
  return createRedirect(request, '/generator/image')
}
clientLoader.hydrate = true

export default function Page() {
  return null
}
